export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_BYTES = 72;

const requirement = (id, label, met) => ({ id, label, met });

// TextEncoder is present in supported browsers, but some test/webview
// environments omit it.  Count Unicode code points directly as a stable
// UTF-8 fallback rather than weakening the server-compatible byte ceiling.
export function utf8ByteLength(value) {
    const text = typeof value === 'string' ? value : '';
    if (typeof TextEncoder !== 'undefined')
        return new TextEncoder().encode(text).length;
    return Array.from(text).reduce((total, character) => {
        const codePoint = character.codePointAt(0) || 0;
        if (codePoint <= 0x7f)
            return total + 1;
        if (codePoint <= 0x7ff)
            return total + 2;
        if (codePoint <= 0xffff)
            return total + 3;
        return total + 4;
    }, 0);
}

/**
 * Client-side guidance only. The server remains the final policy authority.
 * This module deliberately never persists, logs, or transforms a password.
 */
export function evaluatePassword(password) {
    const value = typeof password === 'string' ? password : '';
    const byteLength = utf8ByteLength(value);
    const hasLetter = /\p{L}/u.test(value);
    const hasLowercase = /[a-z]/.test(value);
    const hasUppercase = /[A-Z]/.test(value);
    const hasDigit = /\p{N}/u.test(value);
    const hasSymbol = /[\p{P}\p{S}]/u.test(value);
    const requirements = [
        requirement('length', `12 حرفاً على الأقل (${value.length}/${PASSWORD_MIN_LENGTH})`, value.length >= PASSWORD_MIN_LENGTH),
        requirement('max-bytes', `لا تتجاوز ${PASSWORD_MAX_BYTES} بايتاً (${byteLength}/${PASSWORD_MAX_BYTES})`, byteLength <= PASSWORD_MAX_BYTES),
        requirement('letter', 'حرف واحد على الأقل', hasLetter),
        requirement('digit', 'رقم واحد على الأقل', hasDigit),
        requirement('symbol', 'رمز خاص واحد على الأقل', hasSymbol),
        requirement('case-variety', 'تنويع حالة الأحرف عند استخدامها', hasLowercase && hasUppercase),
    ];
    const classesMet = Number(hasLetter) + Number(hasDigit) + Number(hasSymbol) + Number(hasLowercase && hasUppercase);
    const eligible = requirements[0].met && requirements[1].met && classesMet >= 3;
    const score = value.length === 0 ? 0 : Math.min(4, classesMet + (requirements[0].met ? 1 : 0));
    const strength = score <= 1 ? 'ضعيفة' : score <= 3 ? 'متوسطة' : 'قوية';
    return { requirements, classesMet, eligible, score, strength };
}

export function passwordsMatch(password, confirmation) {
    return Boolean(password) && password === confirmation;
}
